import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-Truck',
  standalone: true,
  templateUrl: '../../assets/Truck.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamTruckIcon {}
